import React from "react";
import { Field } from "./Field";
import styles from "./ui.module.css";

export const TextInput = ({
  label,
  id,
  value,
  onChange,
  onBlur,
  disabled = false,
  error,
  placeholder,
  className = "",
}) => {
  const inputClass = `${styles.textInput} ${error ? styles.inputError : ""} ${className}`;
  return (
    <Field label={label} htmlFor={id} error={error}>
      <input
        type="text"
        id={id}
        value={value ?? ""}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        placeholder={placeholder}
        className={inputClass}
      />
    </Field>
  );
};